import './styles/job-id.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'

import { Button } from 'semantic-ui-react'

import DetailsSection from '../components/DetailsSection'

const ANIMATION_DELAY = 150
const DISPLAY_DELAY = 750

const COPY_TEXT   = ' Copy'
const COPIED_TEXT = 'Copied'

export default class JobId extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
  }

  state = {
    text: COPY_TEXT,
    justCopied: false,
    justCopiedConfirm: false,
  }

  handleCopy = () => {
    const textField = document.createElement('textarea')
    textField.innerText = this.props.id
    document.body.appendChild(textField)
    textField.select()
    document.execCommand('copy')
    textField.remove()

    this.setState({ justCopied: true, justCopiedConfirm: false, initted: true }, () => {
      setTimeout(() => {
        this.setState({ justCopied: false, justCopiedConfirm: true, text: COPIED_TEXT }, () => {
          setTimeout(() => {
            this.setState({ justCopied: true, justCopiedConfirm: false }, () => {
              setTimeout(() => {
                this.setState({ justCopied: false, justCopiedConfirm: false, text: COPY_TEXT })
              }, ANIMATION_DELAY)
            })
          }, DISPLAY_DELAY)
        })
      }, ANIMATION_DELAY)
    })
  }

  render() {
    const { justCopied, justCopiedConfirm, text } = this.state

    const buttonClass = classnames('copy-button', {
      'just-copied':         justCopied,
      'just-copied-confirm': justCopiedConfirm,
    })
    
    return (
      <div className="job-id">
        <DetailsSection title="Job ID">
          <div className="job-id-content">
            <span>{ this.props.id }</span>
              <Button basic className={buttonClass} onClick={this.handleCopy}>{ text }</Button>
          </div>
        </DetailsSection>  
      </div>
    )
  }
}